<template>
  <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9.5 0H1.83333C0.82 0 0 0.82 0 1.83333V12.1667C0 13.18 0.82 14 1.83333 14H6.22667C5.86667 13.24 5.66667 12.3933 5.66667 11.5C5.66667 10.7333 5.81333 10 6.08667 9.32667C6.06 9.33333 6.03333 9.33333 6 9.33333H2.66667C2.3 9.33333 2 9.03333 2 8.66667C2 8.3 2.3 8 2.66667 8H6C6.25333 8 6.48 8.14667 6.58667 8.36C7.02 7.68667 7.58 7.11333 8.24 6.66667H2.66667C2.3 6.66667 2 6.36667 2 6C2 5.63333 2.3 5.33333 2.66667 5.33333H8.66667C9.03333 5.33333 9.33333 5.63333 9.33333 6C9.33333 6.03333 9.33333 6.06 9.32667 6.08667C9.94667 5.83333 10.6267 5.68667 11.3333 5.67333V1.83333C11.3333 0.82 10.5133 0 9.5 0V0ZM5.33333 4H2.66667C2.3 4 2 3.7 2 3.33333C2 2.96667 2.3 2.66667 2.66667 2.66667H5.33333C5.7 2.66667 6 2.96667 6 3.33333C6 3.7 5.7 4 5.33333 4Z"
        fill="currentColor"/>
    <path
        d="M11.5 7C9.01867 7 7 9.01867 7 11.5C7 13.9813 9.01867 16 11.5 16C13.9813 16 16 13.9813 16 11.5C16 9.01867 13.9813 7 11.5 7ZM13.3333 12.1667H12.1667V13.3333C12.1667 13.7013 11.868 14 11.5 14C11.132 14 10.8333 13.7013 10.8333 13.3333V12.1667H9.66667C9.29867 12.1667 9 11.868 9 11.5C9 11.132 9.29867 10.8333 9.66667 10.8333H10.8333V9.66667C10.8333 9.29867 11.132 9 11.5 9C11.868 9 12.1667 9.29867 12.1667 9.66667V10.8333H13.3333C13.7013 10.8333 14 11.132 14 11.5C14 11.868 13.7013 12.1667 13.3333 12.1667Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconAddSpace"
}
</script>

<style scoped>

</style>